import React from 'react';
import ProgressStyle from './statusStyle';

const ProgressBar = ({ progress, steps }) => {
  // Calcule a largura de cada passo como uma porcentagem
  const widthPerStep = 100 / (steps - 1);

  // Ajuste para iniciar o preenchimento no centro do primeiro ponto
  const fillWidth = progress > 0 ? ((progress - 1) * widthPerStep) + 10 : 0;

  return (
    <ProgressStyle>
      <div className="progress-bar-container">
        <div className="progress-bar">
          {/* Barra de preenchimento */}
          <div className="progress-bar-fill" style={{ width: `${fillWidth}%` }}></div>

          {/* Pontos */}
          {Array.from({ length: steps }, (_, index) => (
            <div
              key={index}
              className={`progress-dot ${progress > index ? "progress-dot-active" : ""}`}
              style={{
                left: `${index * widthPerStep}%`,
                // Ajustar se o ponto for o primeiro ou o último
                marginLeft: index === 0 ? '-5px' : (index === steps - 1 ? '-5px' : '')
              }}
            ></div>
          ))}
        </div>
      </div>
    </ProgressStyle>
  );
};

export default ProgressBar;
